/**
 * Popover.Disclosure component
 */
import * as React from "react"
import styled from "@oui/system"
import { Components, interpolations } from "@oui/system/components"
import ToggleButton from "../ToggleButton"
import { omit } from "ramda"

type Appearance = keyof Components["Popover"]["Disclosure"]["appearances"]
type ToggleButtonProps = Omit<
  React.ComponentPropsWithoutRef<typeof ToggleButton>,
  "appearance" | "from"
>
type DefaultProps = typeof defaultProps
type Props = {
  visible: boolean
} & ToggleButtonProps &
  DefaultProps

const defaultProps = {
  appearance: "default" as Appearance
}

const PopoverDisclosure = ({
  forwardedRef,
  ...rest
}: Props & { forwardedRef: React.Ref<HTMLButtonElement> }) => (
  <ToggleButton
    {...omit(["appearance", "visible"], rest)}
    ref={forwardedRef}
    from="button"
  />
)
PopoverDisclosure.defaultProps = defaultProps

const ForwardedPopoverDisclosure_ = (
  props: Props,
  ref: React.Ref<HTMLButtonElement>
) => <PopoverDisclosure {...props} forwardedRef={ref} />
ForwardedPopoverDisclosure_.displayName = "forwarded(PopoverDisclosure)"

const ForwardedPopoverDisclosure = React.forwardRef(ForwardedPopoverDisclosure_)
ForwardedPopoverDisclosure.defaultProps = defaultProps

const StyledPopoverDisclosure = styled(
  ForwardedPopoverDisclosure
).attrs(props => ({ ...defaultProps, ...props }))(
  {},
  interpolations.Menu.Disclosure.appearance
)

export { PopoverDisclosure as _PropsComponent_ }
export default StyledPopoverDisclosure
